import type { FC } from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import type { IDomain } from "app/pages/industry-analysis/market-builder/MarketBuilder.types";
import RecomendationListItem from "./RecomendationListItem";
import { allTrackers } from "app/services/track/track";

const RecomendationsListWrapper = styled.div``;

interface IRecomendationsList {
    domainsList: IDomain[];
    addToList: (IDomain) => void;
    isDisabled: boolean;
}

const RecomendationsList: FC<IRecomendationsList> = ({ domainsList, addToList, isDisabled }) => {
    const [filteredDomainsList, setFilteredDomainsList] = useState<IDomain[]>(domainsList);

    const addClicked = (domain: IDomain) => {
        allTrackers.trackEvent("Button", "click", `By websites/Recommendations/Add site`);
        addToList(domain);
    };

    useEffect(() => {
        setFilteredDomainsList(domainsList);
    }, [domainsList]);

    return (
        <RecomendationsListWrapper data-automation="RecomendationsList">
            {filteredDomainsList.map((entity, index) => (
                <RecomendationListItem
                    entity={entity}
                    onAddClick={addClicked}
                    key={`${index}-${entity?.domain}`}
                    isDisabled={isDisabled}
                />
            ))}
        </RecomendationsListWrapper>
    );
};

export default RecomendationsList;
